// extracted by mini-css-extract-plugin
var _1 = "BookingsDayList_day__H0pfh";
var _2 = "BookingsDayList_label__y9fI8";
export { _1 as "day", _2 as "label" }
